<template>
	<div>
		<div class="loading-progress-btn" v-show="isLoading"></div>

		<div class="loading-progress-logo" v-show="isLogoLoading"></div>

		<div v-if="isComplete">{{completeText}}</div>
	</div>
</template>
<script>
	export default{
		name:'Loading',
		props:{
			isLoading:{
				type:Boolean,
				default:false
			},
			isLogoLoading:{
				type:Boolean,
				default:false
			},
			isComplete:{
				type:Boolean,
				default:false
			},
			completeText:{
				type:String,
				default:'没有更多数据了'
			}
		}

	}
</script>


// WEBPACK FOOTER //
// src/common/cmpnt/Loading/Loading.vue